/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MessagingChannel } from "./MessagingChannel";
import {
  MessagingChannelFromJSON,
  MessagingChannelFromJSONTyped,
  MessagingChannelToJSON,
  MessagingChannelToJSONTyped,
} from "./MessagingChannel";

/**
 *
 * @export
 * @interface MessagingChannelCollection
 */
export interface MessagingChannelCollection {
  /**
   *
   * @type {Array<MessagingChannel>}
   * @memberof MessagingChannelCollection
   */
  channels: Array<MessagingChannel>;
}

/**
 * Check if a given object implements the MessagingChannelCollection interface.
 */
export function instanceOfMessagingChannelCollection(
  value: object
): value is MessagingChannelCollection {
  if (!("channels" in value) || value["channels"] === undefined) return false;
  return true;
}

export function MessagingChannelCollectionFromJSON(
  json: any
): MessagingChannelCollection {
  return MessagingChannelCollectionFromJSONTyped(json, false);
}

export function MessagingChannelCollectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MessagingChannelCollection {
  if (json == null) {
    return json;
  }
  return {
    channels: (json["channels"] as Array<any>).map(MessagingChannelFromJSON),
  };
}

export function MessagingChannelCollectionToJSON(
  json: any
): MessagingChannelCollection {
  return MessagingChannelCollectionToJSONTyped(json, false);
}

export function MessagingChannelCollectionToJSONTyped(
  value?: MessagingChannelCollection | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    channels: (value["channels"] as Array<any>).map(MessagingChannelToJSON),
  };
}
